<template>
  
    <div :class="imagetype">
    <NuxtImg
      v-if="mediaData.image.url"
      :src="toImgixPath(mediaData.image.url)"
      provider="imgix"
      format="webp"
      fit="crop"
      class="w-full"
      :modifiers="{ 
        ar: '1:1',
        auto: 'format,compress',        
        'fp-x': mediaData.presentation ? mediaData.presentation.asJson.focalPoint.x : 0.5,
        'fp-y': mediaData.presentation ? mediaData.presentation.asJson.focalPoint.y : 0.5,
      }"/>
    </div>
</template>
  
    
<script setup>
  import { useImageUtils } from '@/composables/useImageUtils';
  const {toImgixPath} = useImageUtils();
    // Props
    const props = defineProps({
      mediaData: {
        type: Object,
        required: true
      },
      alt: {
        type: String,
        default: 'Image'
      },
      width: {
        type: [String, Number],
        default: 349
      },
      height: {
        type: [String, Number],
        default: 349
      },
      sizes: {
        type: String,
        default: 'sm:240px md:480px lg:720px xl:960px'
      },
      imagetype: {
        required: false,
        type: String,
        default: 'hoverimage'
      }
    });
  
    
   
</script>
    
<style scoped>
@reference "../../assets/css/main.css";
  .product{
    @apply bg-gravaalightwarmgray;
  }

</style>